export default "__VITE_ASSET__B8uy$F$E__"